import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import IdTokenVerifier from 'idtoken-verifier';
import getOAuthServerMetadata from '../config/getOAuthServerMetadata';
export default function validate(token, clientConfig, authServerConfig) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var serverMetadata, verifier;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            serverMetadata = getOAuthServerMetadata(authServerConfig);
            verifier = new IdTokenVerifier({
              issuer: serverMetadata.issuer,
              audience: clientConfig.clientId,
              jwksURI: serverMetadata.jwksUrl,
              jwksCache: new Map()
            });
            _context.next = 4;
            return new Promise(function (resolve, reject) {
              verifier.verify(token, '', function (err, payload) {
                if (err) {
                  return reject('Invalid token');
                }

                return resolve(payload);
              });
            });

          case 4:
            return _context.abrupt("return", _context.sent);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}